import React, {useEffect, useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Controller, useForm} from 'react-hook-form';
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {authPath, rootMainPath} from '../../../routes/paths';
import {postSignIn} from '../../../redux/actions/auth/authActions';
import InputMUI from '../../../shared/InputMUI';
import ButtonMUI from '../../../shared/ButtonMUI';
import Social from '../Social';
import EmailIcon from '../../../assets/icons/email.svg';
import passIcon from '../../../assets/icons/pass.svg';
import {ReactComponent as CloseIcon} from '../../../assets/icons/close.svg';
import {ReactComponent as InfoIcon} from '../../../assets/icons/info.svg';
import employeeBg from '../../../assets/images/auth/Sotrudnik_bg.jpg';
import clientBg from '../../../assets/images/auth/klient-img.jpg';
import employeeMob from '../../../assets/images/auth/sotrudnik-mob.jpg';
import clientMob from '../../../assets/images/auth/klient-mob.jpg';
import {useTranslation} from 'react-i18next';
import {isDev} from "../../../config";

const SignIn = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {buttonLoading} = useSelector(({app}) => app);

  const [user, setUser] = useState('employee');
  const [clientInfo, setClientInfo] = useState(true);
  const {t} = useTranslation();
  useEffect(() => {
    localStorage.getItem('token') && history.push(rootMainPath);
  }, []);

  const schema = yup.object({
    email: yup.string().email(t('validations.email')).required(t('validations.required')),
    password: yup.string().min(8, t('validations.min8')).required(t('validations.required'))
  });

  const {
    control,
    handleSubmit,
    formState: {errors, isValid, isSubmitting}
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
      password: ''
    }
  });

  const onSubmit = async (data) => {
    // data.type = user;
    const res = await dispatch(postSignIn(data));
    if (res.payload && res.payload.status === 200) {
      localStorage.setItem('token', res.payload.data.accessToken);
      localStorage.setItem('refreshToken', res.payload.data.refreshToken);
      history.push(rootMainPath);
    }
  };

  const handleClientInfoClose = () => {
    setClientInfo(false);
  };

  return (
    <div className='auth-page__content'>
      <div className='auth-page__bg'>
        {user === 'employee' && <img src={employeeBg} alt='images' />}
        {user === 'client' && <img src={clientBg} alt='images' />}
      </div>
      <div className='auth-box__wrapper'>
        <div />
        <form className='auth-box' onSubmit={handleSubmit(onSubmit)} autoComplete={'off'}>
          <div className='auth-box__head'>
            <div className='auth-box__mini-icon'>
              {user === 'employee' && <img src={employeeMob} alt='images' />}
              {user === 'client' && <img src={clientMob} alt='images' />}
            </div>

            <div className='auth-box__title'>{t('auth.login')}</div>

            {/*<div className='auth-box__users'>*/}
            {/*  <div*/}
            {/*    onClick={() => setUser('employee')}*/}
            {/*    className={`btn_user employee ${user === 'employee' && 'active'}`}*/}
            {/*  >*/}
            {/*    {user !== 'employee' && <SotrudnikIcon />}*/}
            {/*    {user === 'employee' && <OkIcon />}*/}
            {/*    <div>{t('auth.employee')}</div>*/}
            {/*  </div>*/}

            {/*  <div onClick={() => setUser('client')} className={`btn_user client ${user === 'client' && 'active'}`}>*/}
            {/*    {user !== 'client' && <KlientIcon />}*/}
            {/*    {user === 'client' && <OkIcon />}*/}
            {/*    <div>{t('auth.client')}</div>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          {user === 'client' && clientInfo === true && (
            <div className='auth-box__client'>
              <div className='auth-box__client-icon'>
                <InfoIcon />
              </div>
              <div className='auth-box__client-text'>
                <div className='auth-box__client-title'>{t('auth.dataLogin')}</div>
                <div className='auth-box__client-descriptions'>{t('auth.contactManager')}</div>
              </div>
              <div className='auth-box__client-icon close' onClick={handleClientInfoClose}>
                <CloseIcon />
              </div>
            </div>
          )}

          {/*{user === 'employee' && (*/}
          {/*  <div className='auth-box__info'>*/}
          {/*    <div className='auth-box__text-bold'>{t('auth.noAccount')}</div>*/}
          {/*    <Link className='auth-box__link' to={authPath.signUp}>*/}
          {/*      {t('auth.signUp')}*/}
          {/*    </Link>*/}
          {/*  </div>*/}
          {/*)}*/}

          <div className='auth-box__input_wrapper'>
            <div className='auth-box__input_box'>
              <Controller
                name='email'
                control={control}
                render={({field}) => (
                  <InputMUI
                    className='auth-box__input'
                    type='email'
                    fullWidth
                    autoComplete='new-password'
                    error={errors.email?.message}
                    inputProps={field}
                    label='E-mail'
                    startAdornment={EmailIcon}

                  />
                )}
              />
              <span className='input-info'>{t('auth.enterEmail')}</span>
            </div>
            <div className='auth-box__input_box'>
              <Controller
                name='password'
                control={control}
                render={({field}) => (
                  <InputMUI
                    className='auth-box__input'
                    type='password'
                    fullWidth
                    autoComplete='new-password'
                    error={errors.password?.message}
                    inputProps={field}
                    label={t('auth.passwordLabel')}
                    startAdornment={passIcon}
                  />
                )}
              />
            </div>
            <div className='auth-box__info'>
              <Link className='auth-box__link' to={authPath.passRecovery}>
                {t('auth.forgotPassword')}
              </Link>
            </div>
          </div>

          <ButtonMUI disabled={!isValid || buttonLoading || isSubmitting} loading={isSubmitting} formAction>
            {t('auth.signIn')}
          </ButtonMUI>

          <div className='auth-box__info-text'>
            <div className='text'>{t('auth.authWith')}</div>
          </div>

          <Social />
        </form>

        <div className='auth-box__subscribe'>{t('SideBgFooter.copyright', {year: new Date().getFullYear()})}</div>
      </div>
    </div>
  );
};

export default SignIn;
